import React, { useState } from "react";
import { useGetMyRentCorpQuery } from "@/redux/rentCorpApi";

export const AosReceiptSelectionTable = ({ onSelect, aosReceiptData, selectedAosReceipt }) => {
    // 사업자 리스트 조회
    //const { data: myRentCorpData, isLoading } = useGetMyRentCorpQuery();

    const handleAosReceiptSelect = (index) => {
        //console.log(index);
        onSelect(index);
    };

    return (
        <div className="rent-corp-table-group">
            <label>접수 목록</label>
            <div className="table-container">
                <div className="table-content">
                    <div className="table-wrapper">
                        <div className="table">
                            <table>
                                <colgroup>
                                    <col width="5%"/>
                                    <col width="15%"/>
                                    <col width="10%"/>
                                    <col width="10%"/>
                                    <col width="10%"/>
                                    <col width="10%"/>
                                    <col width="10%"/>
                                    <col width="10%"/>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th>
                                        <div className="cell">
                                            <div className="cell-tit">선택</div>
                                        </div>
                                    </th>
                                    <th>
                                        <div className="cell">
                                            <div className="cell-tit">사고접수번호</div>
                                        </div>
                                    </th>
                                    <th>
                                        <div className="cell">
                                            <div className="cell-tit">사고일자</div>
                                        </div>
                                    </th>
                                    <th>
                                        <div className="cell">
                                            <div className="cell-tit">차량번호</div>
                                        </div>
                                    </th>
                                    <th>
                                        <div className="cell">
                                            <div className="cell-tit">보험사</div>
                                        </div>
                                    </th>
                                    <th>
                                        <div className="cell">
                                            <div className="cell-tit">보상담당자명</div>
                                        </div>
                                    </th>
                                    <th>
                                        <div className="cell">
                                            <div className="cell-tit">보상담당자연락처</div>
                                        </div>
                                    </th>
                                    <th>
                                        <div className="cell">
                                            <div className="cell-tit">보상담당자 AOS ID</div>
                                        </div>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                {aosReceiptData && aosReceiptData.data && aosReceiptData.data.length > 0 ? (
                                    aosReceiptData.data.map((aosReceipt, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <div className="cell" style={{height: "100%"}}>
                                                        <div className="input-checkbox">
                                                            <div className="checkbox" style={{display: "flex"}}>
                                                                <input
                                                                    type="radio"
                                                                    name="selectedAosReceipt"
                                                                    id={`selectedAosReceipt-${index}`}
                                                                    checked={selectedAosReceipt === index}
                                                                    onChange={() => handleAosReceiptSelect(index)}
                                                                />
                                                                <label htmlFor={`selectedAosReceipt-${index}`}></label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell">
                                                        <div className="cell-desc">{aosReceipt.accno}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell">
                                                        <div className="cell-desc">{aosReceipt.accymd}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell">
                                                        <div className="cell-desc">{aosReceipt.carnum}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell">
                                                        <div className="cell-desc">{aosReceipt.insnm}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell">
                                                        <div className="cell-desc">{aosReceipt.damcstnnm}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell">
                                                        <div className="cell-desc">{aosReceipt.damcstntel}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell">
                                                        <div className="cell-desc">{aosReceipt.damcstnuid}</div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="data-empty">
                                                <div className="cell" data-align="center">
                                                    <span className="cell-desc">aos 접수 데이터가 없습니다.</span>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
